import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var WarningShieldSvg = function WarningShieldSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.305 13.593V5.722h1.39v7.87zM11.305 16.834v-1.389h1.39v1.389z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.5 2.249h-19v15.004L12 22.25l9.5-4.996zM3.89 16.415V3.638h16.22v12.777L12 20.679z",
    clipRule: "evenodd"
  }));
};
export var WarningShield = function WarningShield(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: WarningShieldSvg
  }));
};